import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { useVideo } from "../../context/VideoContext";
import { getPortalContainer } from "../../utils/portalContainer";
import { getMainLanguageOptions, normalizeLanguage } from "../../utils/languages";

const WatchTwoSubtitlesModal = ({ isOpen, onClose, referenceSubtitle, selectedSubtitle, onAddToPlayer }) => {
  const { isFullscreen, isIOS } = useVideo();
  const [language1, setLanguage1] = useState("en");
  const [language2, setLanguage2] = useState("en");

  const mainCodes = getMainLanguageOptions().map((l) => l.code);

  useEffect(() => {
    const detect = (sub, defaultLang = "en") => {
      if (!sub) return defaultLang;
      const code = sub.language?.toLowerCase().trim();
      const normalized = normalizeLanguage(code);
      if (normalized && mainCodes.includes(normalized)) return normalized;
      return sub.source === "file" ? defaultLang : normalized || defaultLang;
    };
    if (referenceSubtitle) setLanguage1(detect(referenceSubtitle, "en"));
    if (selectedSubtitle) setLanguage2(detect(selectedSubtitle, "fa"));
  }, [referenceSubtitle, selectedSubtitle, mainCodes]);

  const validLangs = getMainLanguageOptions();

  const handleWatch = () => {
    onAddToPlayer(referenceSubtitle, selectedSubtitle, language1, language2);
  };

  if (!isOpen) return null;

  const portalContainer = getPortalContainer(isIOS, isFullscreen);
  const refName = referenceSubtitle?.title || referenceSubtitle?.fileName || "بدون نام";
  const selName = selectedSubtitle?.title || selectedSubtitle?.fileName || "بدون نام";

  return ReactDOM.createPortal(
    <div className="scw-overlay" onClick={(e) => e.stopPropagation()}>
      <div className="scw-modal" style={{ maxWidth: "480px" }} onClick={(e) => e.stopPropagation()}>
        <div className="scw-header">
          <h3>تماشای فیلم با دو زیرنویس</h3>
          <div className="scw-header-actions">
            <button className="scw-close-btn" onClick={onClose}>✕</button>
          </div>
        </div>
        <div className="scw-scrollable" style={{ padding: "20px" }}>
          <div style={{ marginBottom: "16px" }}>
            <div style={{ fontSize: "13px", color: "var(--text-secondary)", marginBottom: "8px" }}>زیرنویس مرجع</div>
            <div style={{ fontSize: "14px", color: "var(--text-primary)", fontWeight: 500, wordBreak: "break-word", marginBottom: "8px" }}>{refName}</div>
            <div style={{ fontSize: "12px", color: "var(--text-muted)", marginBottom: "4px" }}>زیرنویس ۱ - زبان:</div>
            <select
              value={language1}
              onChange={(e) => setLanguage1(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 12px",
                background: "var(--glass-bg-strong)",
                border: "1px solid var(--glass-border-strong)",
                borderRadius: "8px",
                fontSize: "14px",
                cursor: "pointer",
                outline: "none",
              }}
            >
              {validLangs.map((lang) => (
                <option key={lang.code} value={lang.code}>{lang.name}</option>
              ))}
            </select>
          </div>
          <div>
            <div style={{ fontSize: "13px", color: "var(--text-secondary)", marginBottom: "8px" }}>زیرنویس انتخاب شده</div>
            <div style={{ fontSize: "14px", color: "var(--text-primary)", fontWeight: 500, wordBreak: "break-word", marginBottom: "8px" }}>{selName}</div>
            <div style={{ fontSize: "12px", color: "var(--text-muted)", marginBottom: "4px" }}>زیرنویس ۲ - زبان:</div>
            <select
              value={language2}
              onChange={(e) => setLanguage2(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 12px",
                background: "var(--glass-bg-strong)",
                border: "1px solid var(--glass-border-strong)",
                borderRadius: "8px",
                fontSize: "14px",
                cursor: "pointer",
                outline: "none",
              }}
            >
              {validLangs.map((lang) => (
                <option key={lang.code} value={lang.code}>{lang.name}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="scw-footer" style={{ justifyContent: "center", flexDirection: "column", gap: "8px" }}>
          <button
            className="scw-btn scw-btn-primary"
            onClick={handleWatch}
            style={{ padding: "10px 32px", fontSize: "14px", width: "100%" }}
          >
            مشاهده فیلم با دو زیرنویس همزمان
          </button>
        </div>
      </div>
    </div>,
    portalContainer,
  );
};

export default WatchTwoSubtitlesModal;
